import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "custom"
};
var _hoisted_2 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass(['textLink'])
};
var _hoisted_3 = {
  key: 0,
  class: "mergeDo iconfont icon-cuiban"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "textLink_title"
};
var _hoisted_6 = {
  key: 0,
  class: "iconfont icon-lianjie1"
};
var _hoisted_7 = {
  key: 1,
  class: "iconfont icon-bujianfanchangxiulifuwu blk_link",
  style: {
    "font-weight": "bold",
    "font-size": "25px"
  }
};
var _hoisted_8 = {
  key: 2,
  style: {
    "width": "20px"
  },
  src: "https://www.bio-cloud.com.cn:8022/icon/material.png",
  alt: ""
};
var _hoisted_9 = {
  class: "text-ellipsis"
};
var _hoisted_10 = {
  key: 4,
  class: "textLink_titles"
};
var _hoisted_11 = {
  key: 5,
  class: "textLink_gray text-ellipsis_2"
};
var _hoisted_12 = {
  class: "textLink_gray"
};
var _hoisted_13 = {
  class: "textLink_gray"
};
var _hoisted_14 = {
  key: 0
};
var _hoisted_15 = {
  class: "query_models_model"
};
var _hoisted_16 = {
  class: "back"
};
var _hoisted_17 = {
  key: 0,
  class: "blk_primary",
  style: {
    "display": "flex",
    "align-items": "center",
    "justify-content": "space-between"
  }
};
var _hoisted_18 = {
  class: "text-ellipsis",
  style: {
    "width": "450rpx"
  }
};
var _hoisted_19 = ["src"];
var _hoisted_20 = {
  class: "top"
};
var _hoisted_21 = {
  class: "query_models_model_title"
};
var _hoisted_22 = {
  class: "query_models_model_nums"
};
var _hoisted_23 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "justify-content": "space-between"
  }
};
var _hoisted_24 = {
  class: "query_models_model_zuzhi",
  style: {
    "display": "flex",
    "align-items": "center",
    "justify-content": "space-between"
  }
};
var _hoisted_25 = {
  class: "query_models_model_zuzhi_name"
};
var _hoisted_26 = {
  class: "query_models_model_center"
};
var _hoisted_27 = {
  class: "query_models_model_center_models huohao"
};
var _hoisted_28 = {
  class: "query_models_model_center_models_bottom"
};
var _hoisted_29 = {
  class: "query_models_model_center_models"
};
var _hoisted_30 = {
  class: "query_models_model_center_models_bottom"
};
var _hoisted_31 = {
  class: "query_models_model_center_models"
};
var _hoisted_32 = {
  class: "query_models_model_center_models_bottom"
};
var _hoisted_33 = {
  class: "query_models_model_center_models"
};
var _hoisted_34 = {
  class: "query_models_model_center_models_bottom"
};
var _hoisted_35 = {
  key: 1
};
var _hoisted_36 = {
  class: "list_model"
};
var _hoisted_37 = ["src"];
var _hoisted_38 = {
  class: "list_model_left"
};
var _hoisted_39 = {
  class: "list_model_left_title"
};
var _hoisted_40 = {
  class: "list_model_left_title_name",
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
var _hoisted_41 = {
  class: "list_model_left_title_name_txt",
  style: {
    "word-break": "break-all",
    "flex": "1"
  }
};
var _hoisted_42 = {
  class: "list_model_left_title_client"
};
var _hoisted_43 = {
  class: "list_model_left_title_client",
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "min-width": "450rpx"
  }
};
var _hoisted_44 = {
  class: "list_model_left_title_client"
};
var _hoisted_45 = {
  class: "list_model_left_title_client"
};
var _hoisted_46 = {
  class: "phone_link"
};
var _hoisted_47 = {
  key: 2
};
var _hoisted_48 = {
  class: "list_model"
};
var _hoisted_49 = ["src"];
var _hoisted_50 = {
  class: "list_model_left"
};
var _hoisted_51 = {
  class: "list_model_left_title"
};
var _hoisted_52 = {
  class: "list_model_left_title_name",
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
var _hoisted_53 = {
  class: "list_model_left_title_name_txt",
  style: {
    "word-break": "break-all",
    "flex": "1"
  }
};
var _hoisted_54 = {
  class: "list_model_left_title_client"
};
var _hoisted_55 = {
  class: "list_model_left_title_client"
};
var _hoisted_56 = {
  class: "list_model_left_title_client",
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "min-width": "450rpx"
  }
};
var _hoisted_57 = {
  class: "list_model_left_title_client"
};
var _hoisted_58 = {
  class: "phone_link"
};
var _hoisted_59 = {
  key: 3
};
var _hoisted_60 = {
  class: "list_model"
};
var _hoisted_61 = ["src"];
var _hoisted_62 = {
  class: "list_model_left"
};
var _hoisted_63 = {
  class: "list_model_left_title"
};
var _hoisted_64 = {
  class: "list_model_left_title_name",
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
var _hoisted_65 = {
  class: "list_model_left_title_name_txt",
  style: {
    "word-break": "break-all",
    "flex": "1"
  }
};
var _hoisted_66 = {
  class: "list_model_left_title_client"
};
var _hoisted_67 = {
  class: "list_model_left_title_client",
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "min-width": "450rpx"
  }
};
var _hoisted_68 = {
  class: "list_model_left_title_client"
};
var _hoisted_69 = {
  class: "list_model_left_title_client",
  style: {
    "display": "flex"
  }
};
var _hoisted_70 = {
  class: ""
};
var _hoisted_71 = ["innerHTML"];
import { watchEffect, ref, reactive } from '../../../../adapter-vue';
import { JSONToObject } from '../../../../utils/index';
import { useRouter } from 'vue-router';
import { removeRepeat } from '../../../../../util/index';
import linkDetail from '@/views/work_bench/link_todo/detail.vue';
import LinkCreateDialog from '@/views/work_bench/link_todo/add.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-custom',
  props: {
    messageItem: {
      default: undefined
    },
    content: {
      default: undefined
    }
  },
  setup(__props) {
    var router = useRouter();
    var props = __props;
    var custom = ref();
    var message = ref();
    var extension = ref();
    var isCustom = ref('');
    var description = ref('');
    var dataOwn = reactive({
      dialogLinkDetail: false,
      dialogLinkAdd: false,
      linkParams: {
        customMessageType: 'link',
        source: '',
        link_id: ''
      }
    });
    var getIcon = () => {
      if (extension.value.type == 1) {
        return 'icon-xiansuoku';
      } else if (extension.value.type == 2) {
        return 'icon-shangji';
      } else if (extension.value.type == 3) {
        return 'icon-customer';
      } else if (extension.value.type == 4) {
        return 'https://www.bio-cloud.com.cn:8022/icon/goods_green.png';
      } else if (extension.value.type == 5) {
        return 'icon-chakan';
      } else if (extension.value.type == 7) {
        return 'icon-customer';
        // return 'https://www.bio-cloud.com.cn:8022/icon/material.png'
      }
    };
    var hanlde_to_source = () => {
      if (extension.value.source_id) {
        var id = extension.value.source_id;
        console.log("id yj--->", id);
        if (extension.value.type == 1) {
          router.push('/work_bench/clue_detail/' + id);
        }
        if (extension.value.type == 2) {
          router.push('/work_bench/business_detail/' + id);
        }
        if (extension.value.type == 3) {
          router.push('/work_bench/client_detail/' + id);
        }
        if (extension.value.type == 5) {
          router.push('/work_bench/sample_detail/' + id);
        }
      }
    };
    watchEffect(() => {
      custom.value = props.content;
      message.value = props.messageItem;
      var {
        payload
      } = props.messageItem;
      // console.log("payload--->", payload)
      isCustom.value = payload.data || '';
      description.value = payload.description || '';
      isCustom.value = JSONToObject(payload.data);
      if (isCustom.value == 'link' || isCustom.value == 'demo' || isCustom.value == 'material_customization' || isCustom.value == 'share') {
        extension.value = JSON.parse(JSON.parse(JSON.stringify(payload.extension)));
        // console.log("extension-->", extension.value)
        if (typeof extension.value == 'object' && isCustom.value != 'share') {
          if (extension.value.user_ids) {
            var arr = [];
            extension.value.user_ids.map(x => {
              x.userids.map(a => {
                arr.push(a.name);
              });
            });
            arr = removeRepeat(arr);
            var str = arr.join(',');
            extension.value.desc = "".concat(str, "\u7B49").concat(arr.length, "\u4EBA\u6267\u884C");
          }
        }
        if (typeof getIcon === 'function') {
          extension.value.type_icon = getIcon();
        }
      }
    });
    // 查看待办详情
    var handel_view_linkdetail = () => {
      dataOwn.dialogLinkDetail = true;
    };
    var handle_click_share = () => {
      if (extension.value.type == 1) {
        router.push('/work_bench/clue_detail/' + extension.value.id);
      }
      if (extension.value.type == 2) {
        router.push('/work_bench/business_detail/' + extension.value.id);
      }
      if (extension.value.type == 3) {
        router.push('/work_bench/client_detail/' + extension.value.id);
      }
      if (extension.value.type == 4) {
        if (extension.value.share_item.title) {
          router.push('/product_display/product_detail?id=' + extension.value.share_item.classify_id);
        }
      }
      if (extension.value.type == 5) {
        router.push('/work_bench/sample_detail/' + extension.value.id);
      }
    };
    var editLink = link_id => {
      dataOwn.linkParams.source = extension.value.source;
      dataOwn.linkParams.link_id = link_id;
      dataOwn.linkParams.customMessageType = isCustom.value;
      dataOwn.dialogLinkDetail = false;
      dataOwn.dialogLinkAdd = true;
      console.log("dataOwn.linkParams->", dataOwn.linkParams);
    };
    return (_ctx, _cache) => {
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_unref(isCustom) == 'link' || _unref(isCustom) == 'demo' || _unref(isCustom) == 'material_customization' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_unref(description) == '催办待办' ? (_openBlock(), _createElementBlock("span", _hoisted_3)) : _createCommentVNode("", true), _unref(extension).type_icon && _unref(extension).type_icon.indexOf('https://www.bio-cloud.com.cn:8022') != -1 ? (_openBlock(), _createElementBlock("img", {
        key: 1,
        class: "iconbiaoshi",
        style: {
          "width": "20px"
        },
        src: _unref(extension).type_icon,
        alt: ""
      }, null, 8, _hoisted_4)) : (_openBlock(), _createElementBlock("span", {
        key: 2,
        class: _normalizeClass(["iconbiaoshi", [_unref(extension).type_icon, 'iconfont']])
      }, null, 2)), _createElementVNode("div", _hoisted_5, [_unref(isCustom) == 'link' ? (_openBlock(), _createElementBlock("span", _hoisted_6)) : _createCommentVNode("", true), _cache[3] || (_cache[3] = _createTextVNode("  ")), _unref(isCustom) == 'demo' ? (_openBlock(), _createElementBlock("span", _hoisted_7)) : _createCommentVNode("", true), _cache[4] || (_cache[4] = _createTextVNode("  ")), _unref(isCustom) == 'material_customization' ? (_openBlock(), _createElementBlock("img", _hoisted_8)) : _createCommentVNode("", true), _cache[5] || (_cache[5] = _createTextVNode("  ")), _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(extension).theme ? _unref(extension).theme : _unref(extension).title), 1), _cache[6] || (_cache[6] = _createTextVNode("     "))]), _unref(extension).source_name && _unref(isCustom) == 'link' ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "textLink_titles iconfont_link blk_link",
        style: {
          "font-size": "12px",
          "cursor": "pointer"
        },
        onClick: hanlde_to_source
      }, _toDisplayString(_unref(extension).source_name), 1)) : _createCommentVNode("", true), _unref(extension).bills_code ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 样品申请单号：" + _toDisplayString(_unref(extension).bills_code), 1)) : _createCommentVNode("", true), _unref(extension).desc_notice ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_cache[7] || (_cache[7] = _createElementVNode("span", {
        class: "iconfont iconfont-ziyuan165",
        style: {
          "color": "green"
        }
      }, null, -1)), _createTextVNode("  " + _toDisplayString(_unref(extension).desc_notice), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_cache[8] || (_cache[8] = _createElementVNode("span", {
        class: "iconfont icon-customer"
      }, null, -1)), _createTextVNode(" " + _toDisplayString(_unref(extension).desc), 1)]), _createElementVNode("div", _hoisted_13, [_cache[9] || (_cache[9] = _createElementVNode("span", {
        class: "iconfont icon-jiezhishijian"
      }, null, -1)), _createTextVNode(" 截至时间 " + _toDisplayString(_unref(extension).date), 1)]), _createElementVNode("div", {
        class: "textLink_btn",
        onClick: handel_view_linkdetail
      }, "查看")])) : _unref(isCustom) == 'share' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        onClick: handle_click_share
      }, [_unref(extension).type == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_unref(extension).share_item.breadcrumb ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("text", _hoisted_18, _toDisplayString(_unref(extension).share_item.breadcrumb), 1), _unref(extension).type_icon && _unref(extension).type_icon.indexOf('https://www.bio-cloud.com.cn:8022') != -1 ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "iconbiaoshi",
        style: {
          "width": "20px"
        },
        src: _unref(extension).type_icon,
        alt: ""
      }, null, 8, _hoisted_19)) : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: _normalizeClass([_unref(extension).type_icon, 'iconfont', 'iconbiaoshi'])
      }, null, 2))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(_unref(extension).share_item.name), 1), _createElementVNode("div", _hoisted_22, " ￥" + _toDisplayString(_unref(extension).share_item.price), 1)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("text", _hoisted_25, "货号：" + _toDisplayString(_unref(extension).share_item.product_number) + " ", 1)])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_cache[10] || (_cache[10] = _createElementVNode("div", {
        class: "query_models_model_center_models_top"
      }, " 产品经理 ", -1)), _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(extension).share_item.manager_value), 1)]), _createElementVNode("div", _hoisted_29, [_cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "query_models_model_center_models_top"
      }, " 有效期(月) ", -1)), _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(extension).share_item.expire_time ? _unref(extension).share_item.expire_time : '无数据'), 1)]), _createElementVNode("div", _hoisted_31, [_cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "query_models_model_center_models_top"
      }, " 正常货期 ", -1)), _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(extension).share_item.lead_time ? _unref(extension).share_item.lead_time : '无数据'), 1)]), _createElementVNode("div", _hoisted_33, [_cache[13] || (_cache[13] = _createElementVNode("div", {
        class: "query_models_model_center_models_top"
      }, " 库存量 ", -1)), _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(extension).share_item.inventory), 1)])])])])])) : _unref(extension).type == 1 || _unref(extension).type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_unref(extension).type_icon && _unref(extension).type_icon.indexOf('https://www.bio-cloud.com.cn:8022') != -1 ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "iconbiaoshi",
        style: {
          "width": "20px"
        },
        src: _unref(extension).type_icon,
        alt: ""
      }, null, 8, _hoisted_37)) : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: _normalizeClass([_unref(extension).type_icon, 'iconfont', 'iconbiaoshi'])
      }, null, 2)), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("text", _hoisted_41, " 客户项目：" + _toDisplayString(_unref(extension).share_item.title), 1)]), _createElementVNode("div", _hoisted_42, " 客户名称：" + _toDisplayString(_unref(extension).share_item.company ? _unref(extension).share_item.company : '无'), 1), _createElementVNode("div", _hoisted_43, [_createElementVNode("text", null, "销售员：" + _toDisplayString(_unref(extension).share_item.saler ? _unref(extension).share_item.saler : '无'), 1), _cache[14] || (_cache[14] = _createTextVNode()), _cache[15] || (_cache[15] = _createElementVNode("text", null, null, -1))]), _createElementVNode("div", _hoisted_44, " 联系人：" + _toDisplayString(_unref(extension).share_item.contact_user ? _unref(extension).share_item.contact_user : '无'), 1), _createElementVNode("div", _hoisted_45, [_cache[16] || (_cache[16] = _createTextVNode(" 手机号：")), _createElementVNode("text", _hoisted_46, _toDisplayString(_unref(extension).share_item.phone), 1)])])])])])) : _unref(extension).type == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_unref(extension).type_icon && _unref(extension).type_icon.indexOf('https://www.bio-cloud.com.cn:8022') != -1 ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "iconbiaoshi",
        style: {
          "width": "20px"
        },
        src: _unref(extension).type_icon,
        alt: ""
      }, null, 8, _hoisted_49)) : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: _normalizeClass([_unref(extension).type_icon, 'iconfont', 'iconbiaoshi'])
      }, null, 2)), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("text", _hoisted_53, _toDisplayString(_unref(extension).share_item.client_name), 1)]), _createElementVNode("div", _hoisted_54, " 创建者：" + _toDisplayString(_unref(extension).share_item.create_user_name), 1), _createElementVNode("div", _hoisted_55, " 联系人：" + _toDisplayString(_unref(extension).share_item.contact_user), 1), _createElementVNode("div", _hoisted_56, [_createElementVNode("text", null, "销售员：" + _toDisplayString(_unref(extension).share_item.saler ? _unref(extension).share_item.saler : '无'), 1), _cache[17] || (_cache[17] = _createTextVNode()), _cache[18] || (_cache[18] = _createElementVNode("text", null, null, -1))]), _createElementVNode("div", _hoisted_57, [_cache[19] || (_cache[19] = _createTextVNode(" 手机号：")), _createElementVNode("text", _hoisted_58, _toDisplayString(_unref(extension).share_item.phone), 1)])])])])])) : _unref(extension).type == 5 ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_unref(extension).type_icon && _unref(extension).type_icon.indexOf('https://www.bio-cloud.com.cn:8022') != -1 ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "iconbiaoshi",
        style: {
          "width": "20px"
        },
        src: _unref(extension).type_icon,
        alt: ""
      }, null, 8, _hoisted_61)) : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: _normalizeClass([_unref(extension).type_icon, 'iconfont', 'iconbiaoshi'])
      }, null, 2)), _createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_createElementVNode("text", _hoisted_65, _toDisplayString(_unref(extension).share_item.bills_code), 1)]), _createElementVNode("div", _hoisted_66, " 客户名称：" + _toDisplayString(_unref(extension).share_item.client_name), 1), _createElementVNode("div", _hoisted_67, [_createElementVNode("text", null, "销售员：" + _toDisplayString(_unref(extension).share_item.saler ? _unref(extension).share_item.saler : '无'), 1), _cache[20] || (_cache[20] = _createTextVNode()), _cache[21] || (_cache[21] = _createElementVNode("text", null, null, -1))]), _createElementVNode("div", _hoisted_68, " 收货人：" + _toDisplayString(_unref(extension).share_item.consignee_name), 1), _createElementVNode("div", _hoisted_69, [_cache[22] || (_cache[22] = _createTextVNode(" 物流单号： ")), _createElementVNode("div", _hoisted_70, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(extension).share_item.tracking_number.split(','), (v, i) => {
        return _openBlock(), _createElementBlock("div", {
          class: "blk_primary",
          key: i
        }, _toDisplayString(v), 1);
      }), 128))])])])])])])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("span", {
        key: 2,
        innerHTML: _ctx.content.custom
      }, null, 8, _hoisted_71))]), _createVNode(_component_el_dialog, {
        modelValue: _unref(dataOwn).dialogLinkDetail,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(dataOwn).dialogLinkDetail = $event),
        title: "待办详情",
        "destroy-on-close": "",
        "show-close": true,
        width: "1000px"
      }, {
        default: _withCtx(() => [_createVNode(linkDetail, {
          onEditLink: editLink,
          customMessageType: _unref(isCustom),
          id: _unref(extension).link_id
        }, null, 8, ["customMessageType", "id"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(dataOwn).dialogLinkAdd,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(dataOwn).dialogLinkAdd = $event),
        title: _unref(dataOwn).linkParams.customMessageType == 'link' ? 'Link' : _unref(dataOwn).linkParams.customMessageType == 'demo' ? 'Demo返厂' : '物料定制',
        "destroy-on-close": "",
        "show-close": true,
        width: "600px"
      }, {
        default: _withCtx(() => [_createVNode(LinkCreateDialog, {
          linkParams: _unref(dataOwn).linkParams,
          onHandle_close_linkDialog: _cache[1] || (_cache[1] = $event => _unref(dataOwn).dialogLinkAdd = false)
        }, null, 8, ["linkParams"])]),
        _: 1
      }, 8, ["modelValue", "title"])], 64);
    };
  }
});